import ListingClickModal from './ListingClickModal'
import ListingMapHover from './ListingMapHover'
import ListingTiles from './ListingTiles'

export const ListingMapConfig = {
  Click: ListingClickModal,
  Hover: ListingMapHover,
  Controller: ListingTiles,
}
